import {
  IAuthUser,
  ILoginPayload,
  IResponseUpdateFcmToken,
  IUpdateFcmToken,
  IUpdateInfoPayload,
  SignUpPayload,
} from '~/utils/interface/auth';
import axiosClient from './axiosClient';
import { IParamsGetUser, IResponseGetUserProfile } from '~/utils/interface/user';

const authApi = {
  login(data: ILoginPayload) {
    return axiosClient.post('/api/auth/login', data);
  },
  logout() {
    return axiosClient.post('/api/auth/logout');
  },
  requestOTP(data: SignUpPayload) {
    return axiosClient.post('/api/auth/register/request-otp', data);
  },
  verifyOTP(data: SignUpPayload) {
    return axiosClient.post('/api/auth/register/verify-otp', data);
  },
  refreshToken(params: { refresh_token: string }) {
    return axiosClient.get('/api/auth/refresh', { params });
  },
  changePassword(data: any) {
    return axiosClient.post('/api/users/change-password', data);
  },
  forgertPasswordRequestOTP(data: { phone: string | null }) {
    return axiosClient.post('/api/auth/forgot-password/request-otp', data);
  },
  verifyOTPForgotPassword(data: { phone: string | null; otp: string }) {
    return axiosClient.post('/api/auth/forgot-password/verify-otp', data);
  },
  resetPassword(data: { phone: string | null; new_password: string }) {
    return axiosClient.post('/api/auth/forgot-password/reset', data);
  },
  getInfo() {
    return axiosClient.get<IAuthUser>('/api/auth/info');
  },
  getUserProfile(params?: IParamsGetUser) {
    return axiosClient.get<IResponseGetUserProfile>('/api/users/profile', { params });
  },
  updateInfo(data: IUpdateInfoPayload) {
    return axiosClient.post('/api/auth/update-info', data);
  },
  updateFcmToken(data: IUpdateFcmToken) {
    return axiosClient.post<IResponseUpdateFcmToken>('/api/auth/update-fcm-token', data);
  },
};
export default authApi;
